import React, { useState } from "react";
import { makeStyles, Paper, Grid } from "@material-ui/core";

import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import ContractSummary from "./ContractSummary";
import Costpoint from "./Costpoint";
import EACFunding from "./EACFunding";
import FixedFeeSchedule from "./FixedFeeSchedule";
import HeatMapContractSummary from "./HeatMapContractSummary";
import RichTextWithMui from "./TextEditor";
import ClinDetailsTable from "./ClinDetailsTable";

const useStyles = makeStyles((theme) => ({
  tabPaper: {
    margin: "16px",
  },
  imgTag: {
    marginTop: "15px",
  },
  labelTag: {
    color: "#0070D2",
    fontSize: "14px",
    fontWeight: 500,
  },
  radioBtnDiv: {
    marginTop: "20px",
    marginLeft: "20px",
    marginBottom: "20px",
    display: "flex",
  },
  imgContainer: {
    margin: "16px",
  },
  dropeDown: {
    marginTop: "-40px",
    display: "flex",
    justifyContent: "flex-end",
  },
  menuItems: {
    fontSize: "14px !important",
  },
  viewSelectBox: {
    fontSize: "14px !important",
    border: "1px solid #868686",
    borderRadius: "8px",
    paddingLeft: "8px",
    height: "30px",
    marginLeft: "-20px",
  },
  yearSelectBox: {
    fontSize: "14px !important",
    border: "1px solid #868686",
    borderRadius: "8px",
    paddingLeft: "8px",
    height: "30px",
    marginLeft: "-45px",
  },
  icons: {
    marginTop: "-6px",
  },
  uploadIcon: {
    marginLeft: "-8px",
    cursor: "pointer",
  },
  downloadIcon: {
    cursor: "pointer",
  },
  downloadIemplateIcon: {
    padding: 9,
  },
  tableTitle: {
    width: "220px",
    height: "36px",
    padding: "0 0 0 12px",
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
    borderRadius: "0 10px 0 0",
    display: "flex",
    alignItems: "center",
  },
  actionBtns: {
    float: "right",
    marginTop: "6px",
  },
  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
  },
  editSpan: {
    color: "#0070D2",
    cursor: "pointer",
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px 4px 32px",
    position: "relative",
  },
  editText: {
    fontSize: "13px",
  },
  editIconSpan: {
    position: "absolute",
    top: "5px",
    left: "8px",
  },
  saveBtn: {
    padding: "4px 12px",
    cursor: "pointer",
    color: "#0070D2",
    border: "1px solid #0070D2",
    borderRadius: "20px",
    fontSize: "13px",
  },
  saveBtnDisable: {
    padding: "4px 12px",
    cursor: "pointer",
    color: "#cccccc",
    border: "1px solid #cccccc",
    borderRadius: "20px",
    fontSize: "13px",
  },
}));
const ContractSummaryTab = ({
  heatMapData,
  selectedContract,
  version,
  assumptionData,
  getVersionStatus,
  showAddHeatMap,
  clinDetailsData,
  clins,
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();

  return (
    <>
      <div className={classes.tableTitle}>Contract Summary</div>
      <Paper>
        <Grid container>
          <Grid item lg={4}>
            <Costpoint />
          </Grid>
          <Grid item lg={8} style={{ marginBottom: "32px !important" }}>
            <ContractSummary />
          </Grid>
          <Grid item lg={12}>
            <HeatMapContractSummary
              heatMapData={heatMapData}
              selectedContract={selectedContract}
              showAddHeatMap={(val) => showAddHeatMap(val)}
            />
          </Grid>
          <Grid item lg={12}>
            {assumptionData && (
              <RichTextWithMui
                assumptionData={assumptionData}
                getVersionStatus={getVersionStatus}
              />
            )}
          </Grid>
          <Grid item lg={12}>
            <ClinDetailsTable
              clinDetailsData={clinDetailsData}
              selectedContract={selectedContract}
              version={version}
              getVersionStatus={getVersionStatus}
              clins={clins}
            />
          </Grid>
        </Grid>

        {/* <EACFunding />
        <FixedFeeSchedule /> */}
        {loading && <Loading />}
        {emptyErrMsg && (
          <ActionMessages
            type={msgType}
            isClosed={isClosed}
            message={msgText}
          />
        )}
      </Paper>
    </>
  );
};

export default ContractSummaryTab;
